module.exports = __webpack_public_path__ + "static/media/icon_file_dmg.84cb649b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/asset/image/product/icon_file_dmg.svg
// module id = 153
// module chunks = 0